/**
 * Mobile dApp / Phantom best practices for poker.grudge-studio.com
 * - Prefer in-app Phantom browser (deep link) when no inject provider
 * - Browser SDK google/apple for mobile Safari/Chrome without extension
 * - Never auto-connect on cold load
 */

export function isMobileBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

export function isInPhantomInAppBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return /Phantom/i.test(ua) || Boolean(
    typeof window !== "undefined" &&
      (window as Window & { phantom?: { solana?: unknown } }).phantom?.solana,
  );
}

/**
 * Canonical lobby URL for clean Phantom open (no query clutter).
 */
export function phantomDappUrl(path = "/lobby"): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `https://poker.grudge-studio.com${p}`;
}

/**
 * Open this dApp inside Phantom’s in-app browser (mobile best path).
 * Universal Link browse — inject provider becomes available; less browser chrome.
 * Docs pattern: phantom.app/ul/browse/<urlencoded-https-url>
 */
export function openDappInPhantomBrowser(
  url: string = typeof window !== "undefined" ? window.location.href : "",
): void {
  let target = url || phantomDappUrl("/lobby");
  try {
    const u = new URL(target, "https://poker.grudge-studio.com");
    // Always https production host for Phantom allowlist
    u.protocol = "https:";
    u.host = "poker.grudge-studio.com";
    target = u.toString();
  } catch {
    target = phantomDappUrl("/lobby");
  }
  const browse = `https://phantom.app/ul/browse/${encodeURIComponent(target)}?ref=${encodeURIComponent("https://poker.grudge-studio.com")}`;
  // Prefer navigation so return stack is Phantom → dApp
  window.location.assign(browse);
}

export function solflareMobileBrowse(
  url: string = typeof window !== "undefined" ? window.location.href : "",
): void {
  const target = url || "https://poker.grudge-studio.com/lobby";
  // Solflare deep link for browsing
  window.open(
    `https://solflare.com/ul/v1/browse/${encodeURIComponent(target)}`,
    "_blank",
  );
}
